import * as React from 'react';

const Explore = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='41'
    height='40'
    viewBox='0 0 41 40'
    fill='none'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M21.3466 12.6875L21.3466 26.3532L19.6701 26.3532L19.6701 12.6875L21.3466 12.6875Z'
      fill='#F4F2F2'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20.6198 25.6258L24.9395 21.4004L26.125 22.5599L21.8052 26.7854C21.0844 27.4905 19.9198 27.4846 19.199 26.7895L19.1947 26.7854L14.875 22.5599L16.0605 21.4004L20.3773 25.6229C20.45 25.6918 20.5586 25.6856 20.6198 25.6258Z'
      fill='#F4F2F2'
    />
    <path
      d='M19.6278 13.8125L21.3153 13.8125L21.3153 12.6875L19.6278 12.125L19.6278 13.8125Z'
      fill='#F4F2F2'
    />
    <rect
      x='40'
      y='0.5'
      width='39'
      height='39'
      rx='19.5'
      transform='rotate(90 40 0.5)'
      stroke='#F4F2F2'
    />
  </svg>
);

export default Explore;
